(() => {
  'use strict';
  if (window.vvEditorialCollectionsInitialized) return;
  window.vvEditorialCollectionsInitialized = true;
  // Native hrefs work without JavaScript; retain additional query state too.
  const updateSortLink = link => {
    const original = new URL(link.href, window.location.origin);
    const sort = original.searchParams.get('sort_by');
    if (original.origin !== window.location.origin || !sort) return;
    const destination = new URL(window.location.href);
    if (!destination.pathname.startsWith('/collections/')) return;
    destination.searchParams.set('sort_by', sort);
    destination.searchParams.delete('page');
    destination.searchParams.delete('view');
    link.href = destination.href;
  };
  const initializeSortLinks = () => document.querySelectorAll('.vv-editorial-sort-link').forEach(updateSortLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSortLinks, { once: true });
  else initializeSortLinks();
  // Delegation also covers links inserted by collection AJAX responses.
  for (const eventName of ['click', 'auxclick', 'contextmenu']) {
    document.addEventListener(eventName, event => {
      const link = event.target.closest?.('.vv-editorial-sort-link');
      if (link) updateSortLink(link);
    }, true);
  }
  // Delegate so storefront AJAX and theme-editor replacements retain navigation.
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (select.matches('[data-vv-collection-destination]')) {
      const destination = new URL(select.value, window.location.origin);
      if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/collections/')) return;
      event.stopPropagation();
      window.location.assign(destination.href);
    } else if (select.id === 'SortBy' && select.closest('.vv-editorial-toolbar')) {
      // The legacy sort handler drops native price/availability query filters.
      const destination = new URL(window.location.href);
      destination.searchParams.set('sort_by', select.value);
      destination.searchParams.delete('page');
      destination.searchParams.delete('view');
      event.stopPropagation();
      window.location.assign(destination.href);
    }
  }, true);
})();
